import React, { RefObject } from 'react';
import styled from 'styled-components';
import { SlideElementProps } from '../../presentationManager/PresentationManager';
import {
  LeftPanelBackgroundContainer,
} from '../Grid';

const Container = styled(LeftPanelBackgroundContainer)`
  border-right: 1px solid #cce4e0;
  background-color: #fcfcfc;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.25);
`;

const BoxShadow = React.forwardRef(
  (_unused: SlideElementProps, rootElRef: RefObject<HTMLDivElement>) => (<Container ref={rootElRef}/>),
);

export default BoxShadow;
